import { WellplateImage } from '@shared/types';

function generateWellplate(): WellplateImage {
    const header: string[] = [''];
    for (let i = 1; i <= 12; i++) {
        header.push(i.toString());
    }

    const sideBar = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    const body: any = [];

    sideBar.forEach(element => {
        const row: {
            id: number;
            text: string;
            isSelected: boolean;
            tooltipMessage: string;
            color: string;
            isControl: boolean;
            isOmitted: boolean;
        }[] = [];
        row.push({
            id: 0,
            text: element,
            isSelected: false,
            tooltipMessage: '',
            color: '',
            isControl: false,
            isOmitted: false,
        });
        for (let i = 1; i <= 12; i++) {
            row.push({
                id: i,
                text: '',
                isSelected: false,
                tooltipMessage: '',
                color: '',
                isControl: false,
                isOmitted: false,
            });
        }
        body.push(row);
    });

    return { header: header, body: body };
}

function getRowIndexByLetter(letter: string): number {
    if (letter === 'A') {
        return 0;
    }
    if (letter === 'B') {
        return 1;
    }
    if (letter === 'C') {
        return 2;
    }
    if (letter === 'D') {
        return 3;
    }
    if (letter === 'E') {
        return 4;
    }
    if (letter === 'F') {
        return 5;
    }
    if (letter === 'G') {
        return 6;
    }
    if (letter === 'H') {
        return 7;
    }
    return -1;
}

export const WellplateHelper = {
    generateWellplate,
    getRowIndexByLetter,
};
